<template lang="pug">
  .main-field-info
    v-icon(small @click="dialog = true") fa-thin fa-images
    v-dialog(v-model="dialog" max-width="1000")
      v-card(min-height="500px")
        v-card-text.pa-0
          v-tabs(v-model='tabs' fixed-tabs='' color="primary" slider-color="white")
            v-tab.white--text(href='#select-image')
              | Selecione as Imagens
          v-tabs-items.white.elevation-1(v-model='tabs')
            v-tab-item(value="select-image")
              select-image(
                :id="id"
                :component="component"
                :resultForm="resultForm"
                imageStyle='width: 33%;')
</template>

<script>
import SelectImage from '../inputs/SelectImage'

export default {
  name: 'btn-field-info',

  props: {
    id: {
    },
    component: {
    },
    resultForm: null
  },

  components: {
    SelectImage
  },

  data () {
    return {
      dialog: false,
      tabs: null
    }
  },
  created () {
    this.component.multiple = true
  }
}
</script>

<style lang='stylus' scoped>
.main-field-info
  top -6 px
  right 10 px
</style>



// WEBPACK FOOTER //
// src/components/form/buttons/FieldImage.vue